<app-rback [type]='21' [rurl]='rurl'></app-rback> 

<div class="full-map-wrapper">
  <div class="qqmap-wrapper" id="tmap-full-map-wrapper"></div>
</div>